import type { PersonIdentityDocumentType } from "../../../../../interfaces/businessFull.interface";

export type { PersonIdentityDocumentType };

export const PERSON_IDENTITY_DOCUMENT_TYPE_OPTIONS: ReadonlyArray<{
  value: PersonIdentityDocumentType;
  label: string;
}> = [
  { value: "passport", label: "Passport" },
  { value: "identityCard", label: "Identity card" },
  { value: "driversLicense", label: "Driving licence" },
];

/** The dropdown's label for a wire value. Unknown types pass through as-is. */
export function describeIdentityDocumentType(documentType: string): string {
  return (
    PERSON_IDENTITY_DOCUMENT_TYPE_OPTIONS.find(
      (option) => option.value === documentType
    )?.label ?? documentType
  );
}

const TWO_SIDED_TYPES: ReadonlySet<PersonIdentityDocumentType> =
  new Set<PersonIdentityDocumentType>(["identityCard", "driversLicense"]);

/** Has a back side worth uploading. Never a save-time requirement. */
export function isTwoSidedDocumentType(
  documentType?: PersonIdentityDocumentType | null
): boolean {
  return documentType != null && TWO_SIDED_TYPES.has(documentType);
}
